import type { InterventionTemplateLinkProps } from "./intervention-template-link.type";

import { Space, Typography } from "antd";

import { StateTag } from "@/modules/state-tag";

const { Text } = Typography;

export const InterventionTemplateLinkContent = ({
  template,
  showState,
  showVersion,
}: InterventionTemplateLinkProps) => {
  const { name, state, version } = template;

  return (
    <Space className="intervention-template-link-content">
      {showState && <StateTag value={state} type="interventionTemplate" />}
      <Text>{showVersion ? `${name} v${version}` : name}</Text>
    </Space>
  );
};
